<template>
    <div>
      <a-modal
        v-if="footer"
        :title="title"
        :visible="visible"
        :keyboard="false"
        :maskClosable="maskClosable"
        :destroyOnClose="true"
        :width="width"
        :confirmLoading="loading"
        @cancel="handleCancel"
        @ok="handleOk"
        :okText="okText"
        :cancelText="cancelText"
        :closable="closable"
        :bodyStyle="bodyStyle"
        :footer="null"
        :zIndex="zIndex"
        @afterClose="handleCancel"
      >
        <span slot="closeIcon" class="close-icon">
          <pt-icon type="icon-guanbi-copy"  :title="$t('baseVO.close')"></pt-icon>
        </span>
        <slot name="content"></slot>
      </a-modal>
      <a-modal
        v-else
        :title="title"
        :visible="visible"
        :keyboard="false"
        :maskClosable="maskClosable"
        :destroyOnClose="true"
        :width="width"
        :zIndex="zIndex"
        :confirmLoading="loading"
        @cancel="handleCancel"
        @ok="handleOk"
        :okText="okText"
        :cancelText="cancelText"
        :closable="closable"
        @afterClose="handleCancel"
      >
        <span slot="closeIcon" class="close-icon">
          <pt-icon type="icon-guanbi-copy"  :title="$t('baseVO.close')"></pt-icon>
        </span>
        <div slot="title">
          <slot name="title"></slot>
        </div>
        <slot name="content"></slot>
        <div slot="footer" v-if="$slots.footer">
          <slot name="footer">
            {{ $t('save') }}
          </slot>
        </div>
      </a-modal>
    </div>
</template>

<script>
  export default {
    name: 'ptModal',
    props:{
      title:{
        type:String,
        required:'',
      },
      visible:{
        type:Boolean,
        default:false,
      },
      maskClosable:{
        type:Boolean,
        default:false,
      },
      loading:{
        type:Boolean,
        default: false,
      },
      closable:{
        type:Boolean,
        default:true
      },
      width:{
        type:Number,
        default:700
      },
      zIndex:{
        type:Number,
        default:1000
      },
      bodyStyle:{
        type:Object,
        default(){
          return {}
        }
      },
      okText:{
        type:String,
        default(){
          return this.$t('baseVO.confirm')
        }
      },
      cancelText:{
        type:String,
        default(){
          return this.$t('baseVO.cacel')
        }
      },
      footer:{
        type: Boolean,
        default: false
      }
    },
    watch:{
      // visible(newValue){
      //     if(newValue){
      //       document.getElementsByTagName('body')[0].classList.add("modalScollHide")
      //     }else{
      //       document.getElementsByTagName('body')[0].classList.remove("modalScollHide")
      //     }
      // }
    },
    methods:{
      handleOk(){
        this.$emit('ok')
      },
      handleCancel(){
        console.log("close")
        this.$emit('cancel')
      },
    }
  }
</script>
<style>
  @keyframes rotate{
    from {
      transform: rotate(0deg);
    }
    to {
      transform: rotate(180deg);
    }
  }
  .close-icon:hover{
    animation:rotate 0.5s;
    animation-delay:0.5s;
    animation-iteration-count:1;
    cursor: pointer;
  }
</style>
